import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { logout } from './header.action';
import logo from '../../images/febracis_transparent.png';
import routes from '../../utils/routes';
import './header.css';
import defaultPhoto from '../../images/default.png';

class Header extends React.Component {

    constructor() {
        super();

        this.state = {
            avatarExpanded: false,
        };

        this.listenClick = this.listenClick.bind(this);
    }

    componentDidMount() {
        window.addEventListener('click', this.listenClick, true);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.listenClick, true);
    }

    listenClick(event) {
        if (!event.target.matches('.avatar-img')) {
            this.setState({ avatarExpanded: false });
        }
    }

    logout() {
        this.props.logout();
    }

    render() {
        const { avatarExpanded } = this.state;
        const { photoUrl, location, nickname } = this.props;

        let fullName = nickname;

        const photo = (photoUrl === null || typeof photoUrl === 'undefined' ) ? defaultPhoto : photoUrl;

        return (
            <header>
                <div className='flex-horizontal header-wrapper'>
                    <div className='header-logo flex-horizontal'>
                        <Link to={routes.HOME} className='logo-link'>
                            <img src={logo} alt='Febracis EAD'/>
                            <span>EAD</span>
                        </Link>
                    </div>
                    <div className='header-container flex-horizontal'>
                        <NavItem route={routes.COACH_CLASSES} name='meus cursos' path={location.pathname}/>
                        <div className='header-dropdown'>
                            <div
                                className='header-avatar'
                                onClick={() => this.setState({ avatarExpanded: !avatarExpanded })}>
                                <img
                                    className='avatar-img'
                                    src={photo}
                                    alt='avatar'/>
                            </div>
                            <div className='user-name' title={ fullName }>{ fullName }</div>
                            <div className={'dropdown-content ' + (avatarExpanded ? 'show' : '')}>
                                <div className='arrow'/>
                                <button type='button' className='button-logout' onClick={this.logout.bind(this)}>Sair
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

const NavItem = ({ route, name, path }) =>
    <div className='nav-item'>
        <Link to={route}><span>{name.toUpperCase()}</span></Link>
        { path === route &&
            <div className='nav-item-indicator'/>
        }
    </div>;

const mapStateToProps = ({ login }) => {
    return {
        photoUrl: login.userInfo.photoUrl,
        firstName: login.userInfo.firstName,
        secondName: login.userInfo.secondName,
        nickname: login.userInfo.nickname,
        givenName: login.userInfo.given_name,
        familyName: login.userInfo.family_name,
    };
};

export default connect(mapStateToProps, { logout })(Header);



// WEBPACK FOOTER //
// ./src/components/header/header.js